module.exports = __webpack_public_path__ + "static/media/img-832c3502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/png/blue.png
// module id = 5262
// module chunks = 39